import React, { useState } from 'react';
import { X, Instagram } from 'lucide-react';
import { galleryImages, salonInfo } from '../data/mockData';

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <section id="gallery" className="section-padding bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="section-title mb-4">
            Galerie
          </h2>
          <p className="section-subtitle mb-6">
            Entdecke unsere schönsten Kreationen
          </p>
          
          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            <button 
              onClick={() => setFilter('all')}
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            >
              Alle
            </button>
            <button 
              onClick={() => setFilter('styling')}
              className={`filter-btn ${filter === 'styling' ? 'active' : ''}`}
            >
              Styling
            </button>
            <button 
              onClick={() => setFilter('salon')}
              className={`filter-btn ${filter === 'salon' ? 'active' : ''}`}
            >
              Salon
            </button>
            <button 
              onClick={() => setFilter('products')}
              className={`filter-btn ${filter === 'products' ? 'active' : ''}`}
            >
              Produkte
            </button>
          </div>

          {/* Instagram Link */}
          <a 
            href={salonInfo.contact.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-accent hover:text-accent-dark font-semibold transition-colors"
          >
            <Instagram className="w-5 h-5" />
            <span>Folge uns auf Instagram für mehr</span>
          </a>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredImages.map((image) => (
            <div 
              key={image.id} 
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
            >
              <img 
                src={image.url}
                alt={image.alt}
                className="gallery-image"
              />
              <div className="gallery-overlay">
                <span className="text-white text-sm font-medium">Ansehen</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="lightbox"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="lightbox-close"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <X className="w-6 h-6" />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={selectedImage.url}
              alt={selectedImage.alt}
              className="lightbox-image"
            />
            <p className="text-white text-center mt-4 text-sm">{selectedImage.alt}</p>
          </div>
        </div>
      )}
    </section>
  );
};

